module.exports = __webpack_public_path__ + "static/img/tip_img.27eb575.gif";